/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ChatConversationBatchResponse {
    getFixupPrototypeFunction() { return ChatConversationBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<ChatConversationBatchResponse>): ChatConversationBatchResponse {
        let obj = Object.assign(new ChatConversationBatchResponse(), model);
        ChatConversationBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ChatConversationBatchResponse>): ChatConversationBatchResponse {
        if (!model) return null;
        return ChatConversationBatchResponse.newInstance(<ChatConversationBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ChatConversationBatchResponse) {
        if (!obj) return;

        models.ChatConversationBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ChatConversationBatchResponse): boolean {
        Object.setPrototypeOf(obj, ChatConversationBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.ConversationDetails.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.ConversationDetails; };

}
